import { SeoProps } from '../../components/Seo'

export const onboardingSeoTransformer = (t: any): SeoProps => {
  return {
    title: `${t('seo_title_onboarding')} ${t('site_title_suffix')}`,
    description: `${t('seo_description_onboarding')} ${t(
      'site_description_prefix'
    )}`,
  }
}
